import React, { useEffect, useState } from 'react'
import { Link, Links } from 'react-router-dom';
import DataTable from "react-data-table-component";
import axios from 'axios';

function AdminInbox() {
    const [message, setMessage] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    
    useEffect(() => {
        // Fetch messages from an API or any other source
        const fetchMessages = async () => {
            try {
                const response = await axios.get('/api/messages');
                const data = response.data;
                setMessage(data);
            } catch (error) {
                console.error('Error fetching messages:', error);
            }
        };

        fetchMessages();
    }, []);

    const handleSelect = (id) => {
        setSelectedIds((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter(selectedId => selectedId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };

    const deleteSelectedMessages = async () => {
        try {
            await axios.delete('/api/messages', { data: { ids: selectedIds } });
            setMessage((prevMessages) => prevMessages.filter((message) => !selectedIds.includes(message.id)));
            setSelectedIds([]);
        } catch (error) {
            console.error('Error deleting messages:', error);
        }
    };

    const columns = [
        {
            name: "Select",
            cell: row => (
                <input
                    type="checkbox"
                    checked={selectedIds.includes(row.id)}
                    onChange={() => handleSelect(row.id)}
                />
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        { name: "City", selector: (row) => <Link to={row.city}>{row.city}</Link>, sortable: true },
        { name: "State", selector: (row) => row.state, sortable: true },
        { name: "Active", cell: row => <input type="checkbox" checked /> },
    ];

    const players = [
        { city: "Chicago", state: '	Illinois' },
        { city: "Chicago", state: '	Illinois' },
        { city: "Chicago", state: '	Illinois' },
        { city: "Chicago", state: '	Illinois' },
        { city: "Chicago", state: '	Illinois' },
    ];

    const customStyles = {
        table: {
            style: {
                border: "1px solid #ddd",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#40444d", // Black header row
                color: "#ffffff", // White text for header
            },
        },
        rows: {
            style: {
                "&:nth-of-type(odd)": {
                    backgroundColor: "#dedfdd", // Red background for odd rows
                    // color: "#dedfdd", // White text for odd rows
                },
                "&:nth-of-type(even)": {
                    backgroundColor: "#ffffff", // White background for even rows
                    // color: "#000000", // Black text for even rows
                },
            },
        },
    };
    const buttonStyle = {
        background: "#9cb23b",
        padding: "10px 10px",
        margin: "10px 0px",
        border: "none",
        borderRadius: "25px",
        minWidth: "120px",
        color: "#fff",
        cursor: "pointer", // Optional: Adds pointer cursor
        textAlign: "center",
        marginRight: "20px"
        
    };
  return (
    <div id="page-admin-users" className="page-admin">
      
        <DataTable
            columns={columns}
            data={message}
            pagination
            highlightOnHover
            striped
            customStyles={customStyles}
        />
        <button onClick={deleteSelectedMessages} style={buttonStyle}>Delete Selected</button>        
    </div>
  )
}

export default AdminInbox